import { AfterViewInit, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EventManager } from 'src/app/core';
import { UploaderService } from 'src/app/shared/services/uploader.service';
import { AppQueries } from 'src/app/state';
declare var $;
@Component({
  selector: 'app-add-product-popup',
  templateUrl: './add-product-popup.component.html',
  styleUrls: ['./add-product-popup.component.scss']
})
export class AddProductPopUpComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() id: string;
  isShow: boolean = false;
  editForm = this.fb.group({
    title: ['', [Validators.required]],
    productId: ['', [Validators.required]],
    link: [''],
    image: ['']
  });
  isSaved: boolean = false;
  uploader: FileUploader;
  subscriptions?: Subscription[] = [];
  products: any[] = [];
  constructor(
    // private modalRef : NzModalRef,
    public fb: FormBuilder,
    private toastService: ToastrService,
    public formBuilder: FormBuilder,
    private appQueries: AppQueries,
    public uploaderService: UploaderService,
    public eventManager: EventManager
  ) {

  }
  ngOnInit() {
    this.subscriptions = [
      this.eventManager.subscribe('open-product', (res) => {
        this.isShow = true;
        this.editForm.patchValue({
          title: '',
          link: '',
          image: '',
        });
        this.isSaved = false;
      }),
      this.eventManager.subscribe('close-product', (res) => {
        this.close();
      }),
      this.appQueries.products$
      .subscribe((products) => {
        this.products = (products || []).filter(item => !item.productGold );
      }),
    ]
  }
  ngAfterViewInit(): void {
  }
  ngOnDestroy(): void {
    this.eventManager.destroys(this.subscriptions);
  }
  patchValue(product) {
    product = product || {};
    const body: any = {};
    body.productId = product.id;
    body.title = product.shortName;
    this.editForm.patchValue(body);
  }
  close() {
    this.isShow = false;
  }
  save() {
    this.isSaved = true;
    if (this.editForm.invalid) {
      return;
    }
    const title = this.editForm.value.title ? `<span>${this.editForm.value.title || 'Link'}</span>` : '';
    const product = `CCQ_${this.editForm.value.productId}`;
    this.eventManager.broadcast({
      name: 'add-content-custom-editor',
      content: {
        value: `<link>${title}${product}</link>`
      }
    });
    this.isSaved = false;
    this.editForm.patchValue({
      link: ''
    });
    this.close();
  }
}
